
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.81 11.18L6.63 6 11.71.82a.65.65 0 00.18-.37.4.4 0 00-.1-.34.45.45 0 00-.29-.11.66.66 0 00-.37.19L6 5.32.91.19A.61.61 0 00.55 0a.45.45 0 00-.34.11.4.4 0 00-.1.34.65.65 0 00.18.37L5.37 6 .18 11.18a.62.62 0 00-.18.37.42.42 0 00.11.34.42.42 0 00.33.11.63.63 0 00.37-.19L6 6.58l5.19 5.23a.6.6 0 00.37.19.44.44 0 00.33-.11.45.45 0 00.11-.34.63.63 0 00-.19-.37z"}})])
          )
        }
      }
    